// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input__slot[data-v-29ca9d6c] {\n  margin-bottom: 0px;\n}\n.header[data-v-29ca9d6c] {\n  margin-top: -64px;\n  display: flex;\n  justify-content: flex-end;\n}\n.v-input__slot[data-v-29ca9d6c]:before {\n  border-style: none !important;\n}", ""]);
// Exports
module.exports = exports;
